export default {
  'me.app_bar.title': 'My desktop',
  'me.nav.desktop': 'My desktop',
  'me.nav.companies': 'My companies',
  'me.nav.approvals': 'My approvals',
  'me.nav.tasks': 'My tasks',
  'me.host_company': 'Host company',
  'me.host_company_none': 'No host companies',
  'me.back_to_app': 'Back to app',
  'me.back_to_tenant': 'Back to {{name}}',
  'me.cards.all_companies.title': 'Accounting firm',
  'me.cards.all_companies.description': 'Due work and balance coverage across companies.',
  'me.cards.companies.title': 'My companies',
  'me.cards.companies.description': 'Every tenant you have access to — click to switch into one.',
  'me.cards.approvals.title': 'My approvals',
  'me.cards.approvals.description': 'Approve or reject items waiting for you across all your tenants.',
  'me.cards.tasks.title': 'My tasks',
  'me.cards.tasks.description': 'Open tasks assigned to you across all your tenants.',
  'me.cards.user_settings.title': 'User settings',
  'me.cards.user_settings.description': 'Profile, password, language, notifications.',
  'me.companies.empty': 'You have no tenant access yet.',
  'me.companies.current': 'Current',
  'me.companies.tenant': 'Tenant',
  'me.companies.host': 'Host',
  'me.companies.slug': 'Slug',
  'me.companies.status': 'Status',
  'me.companies.active': 'Active',
  'me.companies.inactive': 'Inactive',
  'me.approvals.no_hosts': 'You have no tenant access yet.',
  'me.approvals.empty': 'Nothing waiting for your approval.',
  'me.approvals.tenant': 'Tenant',
  'me.approvals.entity': 'Entity',
  'me.approvals.invoice_image': 'Image',
  'me.approvals.preview_unavailable': 'This file cannot be previewed. Open the invoice to see its attachments.',
  'me.tasks.no_hosts': 'You have no tenant access yet.',
  'me.tasks.empty': 'No open tasks assigned to you.',
  'me.tasks.tenant': 'Tenant',
  'me.tasks.identifier': 'ID',
  'me.tasks.name': 'Task',
  'me.tasks.stage': 'Stage',
  'me.tasks.deadline': 'Deadline',
};
